<div class="fixed-background">
    <svg class="stethoscope-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
            d="M12 2C8.13 2 5 5.13 5 9c0 3.87 3.13 7 7 7s7-3.13 7-7c0-3.87-3.13-7-7-7zm0 12c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z" />
        <path
            d="M12 4c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
        <path
            d="M12 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" />
        <path
            d="M12 10c-.55 0-1 .45-1-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" />
        <path
            d="M12 14c-1.1 0-2 .9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm0 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" />
        <path
            d="M12 16c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" />
    </svg>
    <svg class="stethoscope-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
            d="M12 2C8.13 2 5 5.13 5 9c0 3.87 3.13 7 7 7s7-3.13 7-7c0-3.87-3.13-7-7-7zm0 12c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z" />
        <path
            d="M12 4c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
        <path
            d="M12 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" />
        <path
            d="M12 10c-.55 0-1 .45-1-1s.45-1 1-1h0c.55-.45 1-1 1-1s.45 1 1 1 .45 1 1 1 .45-1 1-1 .45-1 1-1h0c.55 0 1 .45 1 1s-.45 1-1 1h0c-.55.45-1 .45-1 .45s-.45.45-1 .45-.45.45-1 .45z" />
        <path
            d="M12 14c-1.1 0-2 .9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm0 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" />
        <path
            d="M12 16c-.55 0-1 .45-1 1-1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" />
        <path
            d="M12 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" />
    </svg>
    <svg class="stethoscope-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
            d="M12 2C8.13 2 5 5.13 5 9c0 3.87 3.13 7 7 7s7-3.13 7-7c0-3.87-3.13-7-7-7zm0 12c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z" />
        <path
            d="M12 4c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
        <path
            d="M12 8c-1.1 0-2 .9-2 2s.9 2 2 2h0c1.1-.45 1-.45 1-.45s.45-.45.45-.45h0c0 .55-.45 .55-.45 .55s-.55 .55-.55 .55h0c-.55 .55-.55 .55-.55 .55s-.45 .45-.45 .45h0c-.55 .55-.55 .55-.55 .55s-.45 .45-.45 .45h0c-.55 .55-.55 .55-.55 .55s-.45 .45-.45 .45h0c-.55 .55-.55 .55-.55 .55s-.45 .45-.45 .45h0c-.55 .55-.55 .55-.55 .55s-.45 .45-.45 .45h0c-.55 .55-.55 .55-.55 .55s-.45 .45-.45 .45h0c1.1 -.9 -1 -1 -1 -1z" />
        <path
            d="M12 10c1.1 -.9 -1 -1 -1 -1s-1 .9 -1 2 1 2 2 2h0c.55 0 1-.45 1-1s-.45-1-1-1zm0 3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z" />
        <path
            d="M12 14c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z" />
        <path
            d="M12 16c-.55 0-1 .45-1 1-1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z" />
        <path
            d="M12 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" />
    </svg>

</div>


@if(!isLoggedIn) {
<div class="header-banner">
    <button mat-button (click)="goHome()" class="home-button">
        <mat-icon>home</mat-icon>
        Home
    </button>
    <div class="top-nav">
        <a [routerLink]="['/register']" routerLinkActive="router-link-active">
            Register
        </a>
        <a [routerLink]="['/login']" routerLinkActive="router-link-active">
            Sign In
        </a>
    </div>
</div>
}

@if(isLoggedIn && registrationFlow === 'practitioner-initiated') {
<div style="background: #2196F3; color: white; padding: 12px 24px; text-align: center;">
    <mat-icon style="vertical-align: middle;">person_add</mat-icon>
    <span style="font-weight: 600; margin-left: 8px;">
        Registering new patient as {{ getUserDisplayName() }}
        ({{ getUserRoleDisplay() }})
    </span>
    <a [routerLink]="['/app/dashboard']" style="color: white; text-decoration: underline; margin-left: 16px;">
        Back to Dashboard
    </a>
</div>
}


<!-- Conspicuous Submit Button at the Top -->


<!-- Validation Error Bar (Sticky - Only shown AFTER submit attempt) -->
@if(showValidationBar && validationErrors.length > 0 && hasAttemptedSubmit){
<div
    style="position: sticky; top: 0; z-index: 1000; background: linear-gradient(135deg, #f44336 0%, #d32f2f 100%); color: white; padding: 16px 24px; box-shadow: 0 4px 12px rgba(0,0,0,0.3); display: flex; align-items: flex-start; justify-content: space-between; gap: 16px;">
    <div style="flex: 1;">
        <div
            style="font-weight: 700; font-size: 16px; margin-bottom: 8px; display: flex; align-items: center; gap: 10px;">
            <mat-icon style="font-size: 24px; width: 24px; height: 24px;">error_outline</mat-icon>
            <span>FHIR Patient Validation</span>
            <div style="display: flex; gap: 12px; margin-left: 12px; font-size: 13px;">
                @if(getRequiredErrorCount() > 0){
                <span
                    style="background: rgba(255,255,255,0.25); padding: 4px 10px; border-radius: 12px; font-weight: 600;">
                    ❌ {{getRequiredErrorCount()}} Required
                </span>
                }
                @if(getRecommendedErrorCount() > 0){
                <span
                    style="background: rgba(255,255,255,0.15); padding: 4px 10px; border-radius: 12px; font-weight: 500;">
                    ⚠️ {{getRecommendedErrorCount()}} Recommended
                </span>
                }
            </div>
        </div>
        <div style="font-size: 13px; opacity: 0.95; line-height: 1.6; margin-left: 34px;">
            @for(error of validationErrors; track error){
            <div style="margin: 4px 0;">• {{error}}</div>
            }
        </div>
        <div style="margin-top: 8px; margin-left: 34px; font-size: 12px; opacity: 0.85; font-style: italic;">
            This validation bar will automatically disappear once all required fields are completed.
        </div>
    </div>
    <button mat-icon-button (click)="dismissValidationBar()" style="color: white; flex-shrink: 0;"
        title="Temporarily dismiss (will reappear on next change)">
        <mat-icon>close</mat-icon>
    </button>
</div>
}

@if(designatedFormFields && designatedRegForm && guardianFormFields && guardianRegForm){
<div class="" style="max-width: 1200px; margin: 30px auto; position: relative;
display: flex; justify-content: center;
">
    <!-- Main content area with tabs -->
    <div style="position: relative; padding-bottom: 80px; width: 100%;">
        <!-- Tab Group -->
        <div style="position: relative; height: max-content; overflow: auto;">



            <mat-tab-group #tabGroup [mat-stretch-tabs]="false" [mat-align-tabs]="'center'"
    [(selectedIndex)]="selectedTabIndex">

                <mat-tab label="Your Details">
                    <div class="" style="max-width: 900px; margin:auto;">
                        @if(showForm){
                        @if(designatedFormFields && designatedRegForm){
                        <app-dynamic-forms-v2 [formFields]="designatedFormFields" [formMetaData]="designatedRegForm"
                            [resetOnSubmit]="false" (formSubmitted)="onDesignatedFormSubmit($event)"
                            (onEveryChange)="onFormValueChange($event)" [customValidators]="customValidators">

                        </app-dynamic-forms-v2>}
                        }@else{
                        <!-- Patient Data Review - Allow editing individual fields -->
                        <app-patient-data-review [formFields]="designatedFormFields" [submittedData]="submittedData"
                            (fieldEdited)="onFieldEdited($event)" (navigateNext)="onNavigateToNext()">
                        </app-patient-data-review>
                        }

                    </div>
                </mat-tab>
                <mat-tab label="Guardian / Dependent Details">
                   <div class="" style="max-width: 900px; margin: auto; padding: 16px;">

<!-- Toggle: Search existing vs enter new — search only available to staff (practitioner-initiated) -->
@if(!isSelfRegistrationFlow) {
<div style="display: flex; gap: 12px; margin-bottom: 24px; flex-wrap: wrap;">
  <button mat-stroked-button
    [color]="useExistingGuardian ? 'primary' : ''"
    (click)="useExistingGuardian = true; clearGuardianSelection()">
    <mat-icon>search</mat-icon>
    Search existing patient
  </button>
  <button mat-stroked-button
    [color]="!useExistingGuardian ? 'primary' : ''"
    (click)="useExistingGuardian = false; clearGuardianSelection()">
    <mat-icon>person_add</mat-icon>
    Enter new guardian details
  </button>
</div>
}

  <!-- SEARCH PATH -->
  @if(useExistingGuardian) {

    @if(!selectedGuardian) {
      <!-- Search box -->
      <div style="position: relative; margin-bottom: 8px;">
        <mat-icon style="position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: #888; z-index: 1;">
          search
        </mat-icon>
        <input
          type="text"
          [value]="guardianSearchQuery"
          (input)="onGuardianSearchInput($any($event.target).value)"
          placeholder="Search by name, phone, or email (min 3 characters)"
          style="width: 100%; padding: 14px 14px 14px 44px; border: 1px solid #ccc;
                 border-radius: 8px; font-size: 15px; box-sizing: border-box;
                 outline: none; transition: border-color 0.2s;"
        />
        @if(guardianSearchLoading) {
          <div style="position: absolute; right: 12px; top: 50%; transform: translateY(-50%);">
            <div style="width: 20px; height: 20px; border: 2px solid #1976d2;
                        border-top-color: transparent; border-radius: 50%;
                        animation: spin 0.7s linear infinite;"></div>
          </div>
        }
      </div>

      <!-- Hint text -->
      @if(guardianSearchQuery.length > 0 && guardianSearchQuery.length < 3) {
        <p style="color: #888; font-size: 13px; margin: 4px 0 12px 4px;">
          Type at least 3 characters to search…
        </p>
      }

      <!-- Error -->
      @if(guardianSearchError) {
        <div style="background: #fdecea; color: #c62828; padding: 10px 14px;
                    border-radius: 6px; margin-bottom: 12px; font-size: 14px;
                    display: flex; align-items: center; gap: 8px;">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px;">error_outline</mat-icon>
          {{ guardianSearchError }}
        </div>
      }

      <!-- Results -->
      @if(guardianSearchResults.length > 0) {
        <div style="border: 1px solid #e0e0e0; border-radius: 8px; overflow: hidden;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.08); margin-bottom: 12px;">
          @for(patient of guardianSearchResults; track patient.fhirId) {
            <div
              (click)="selectGuardian(patient)"
              style="padding: 14px 16px; cursor: pointer; border-bottom: 1px solid #f0f0f0;
                     display: flex; align-items: center; gap: 14px;
                     transition: background 0.15s;"
              onmouseenter="this.style.background='#f5f5f5'"
              onmouseleave="this.style.background='white'">
              <div style="width: 40px; height: 40px; border-radius: 50%; background: #1976d2;
                          display: flex; align-items: center; justify-content: center;
                          color: white; font-weight: 700; font-size: 16px; flex-shrink: 0;">
                {{ patient.fullName?.[0]?.toUpperCase() || '?' }}
              </div>
              <div style="flex: 1; min-width: 0;">
                <div style="font-weight: 600; font-size: 15px; color: #222;">
                  {{ patient.fullName }}
                </div>
                <div style="font-size: 13px; color: #666; margin-top: 2px;
                            display: flex; gap: 16px; flex-wrap: wrap;">
                  @if(patient.birthDate) {
                    <span>DOB: {{ patient.birthDate }}</span>
                  }
                  @if(patient.gender) {
                    <span>{{ patient.gender }}</span>
                  }
                  @if(patient.phoneLast4) {
                    <span>Phone: ****{{ patient.phoneLast4 }}</span>
                  }
                </div>
              </div>
              <mat-icon style="color: #1976d2; flex-shrink: 0;">chevron_right</mat-icon>
            </div>
          }
        </div>
      }

      <!-- No results -->
      @if(!guardianSearchLoading && guardianSearchQuery.length >= 3
          && guardianSearchResults.length === 0 && !guardianSearchError) {
        <div style="text-align: center; padding: 32px 16px; color: #888;">
          <mat-icon style="font-size: 40px; width: 40px; height: 40px; margin-bottom: 8px;">
            person_search
          </mat-icon>
          <p style="margin: 0; font-size: 14px;">No patients found matching "{{ guardianSearchQuery }}"</p>
          <p style="margin: 8px 0 0; font-size: 13px;">
            <button mat-button color="primary" (click)="useExistingGuardian = false">
              Enter guardian details manually instead
            </button>
          </p>
        </div>
      }

      <!-- Relationship field — always shown when searching so user can pick type -->
      @if(guardianSearchQuery.length >= 3) {
        <p style="color: #555; font-size: 13px; margin: 12px 0 4px;">
          After selecting a patient above, also pick the relationship type from the guardian form below.
        </p>
      }
    }

    <!-- Selected guardian confirmation card -->
    @if(selectedGuardian) {
      <div style="border: 2px solid #4caf50; border-radius: 10px; padding: 16px 20px;
                  background: #f1f8e9; margin-bottom: 20px;
                  display: flex; align-items: flex-start; gap: 16px;">
        <mat-icon style="color: #4caf50; font-size: 32px; width: 32px; height: 32px; flex-shrink: 0;">
          check_circle
        </mat-icon>
        <div style="flex: 1;">
          <div style="font-weight: 700; font-size: 16px; color: #2e7d32; margin-bottom: 4px;">
            Guardian selected
          </div>
          <div style="font-size: 15px; color: #333; font-weight: 600;">{{ selectedGuardian.fullName }}</div>
          <div style="font-size: 13px; color: #666; margin-top: 4px; display: flex; gap: 16px; flex-wrap: wrap;">
            @if(selectedGuardian.birthDate) {
              <span>DOB: {{ selectedGuardian.birthDate }}</span>
            }
            @if(selectedGuardian.gender) {
              <span>{{ selectedGuardian.gender }}</span>
            }
          </div>
        </div>
        <button mat-icon-button (click)="clearGuardianSelection()" title="Remove selection"
          style="color: #888; flex-shrink: 0;">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <!-- Still show the relationship dropdown from the form below for the selected guardian -->
      <p style="color: #555; font-size: 14px; margin-bottom: 8px; font-weight: 500;">
        Select the relationship to the patient:
      </p>
    }

    <!-- Always show the relationship dropdown when a guardian is selected or searching -->
   @if(showGuardianForm && (selectedGuardian || guardianSearchQuery.length >= 3)) {
  @if(relationshipOnlyFormFields.length && guardianRegForm) {
    <app-dynamic-forms-v2
      [formFields]="relationshipOnlyFormFields"
      [formMetaData]="guardianRegForm"
      [resetOnSubmit]="false"
      (formSubmitted)="onGuardianFormSubmit($event)"
      [customValidators]="customValidators">
    </app-dynamic-forms-v2>
  }
} @else if(!showGuardianForm && selectedGuardian) {
  <div style="border: 1px solid #e0e0e0; border-radius: 10px; padding: 16px 20px; margin-top: 8px;
              display: flex; align-items: center; justify-content: space-between; gap: 16px;">
    <div>
      <div style="font-weight: 600; font-size: 15px; color: #222;">
        Guardian confirmed: {{ selectedGuardian.fullName }}
      </div>
      <div style="font-size: 13px; color: #666; margin-top: 4px;">
        Relationship: {{ formatFieldValue({fieldApiName: 'relationship'}, guardianSubmittedData?.relationship) }}
      </div>
    </div>
    <button mat-raised-button color="primary" (click)="onGuardianNavigateNext()">
      Next
    </button>
  </div>
}
  }

  <!-- MANUAL ENTRY PATH -->
  @if(!useExistingGuardian) {
    @if(showGuardianForm) {
      @if(guardianFormFields && guardianRegForm) {
        <app-dynamic-forms-v2
          [formFields]="guardianFormFields"
          [formMetaData]="guardianRegForm"
          [resetOnSubmit]="false"
          (formSubmitted)="onGuardianFormSubmit($event)"
          [customValidators]="customValidators">
        </app-dynamic-forms-v2>
      }
    } @else {
      <app-patient-data-review
        [formFields]="guardianFormFields"
        [submittedData]="guardianSubmittedData"
        (fieldEdited)="onGuardianFieldEdited($event)"
        (navigateNext)="onGuardianNavigateNext()">
      </app-patient-data-review>
    }
  }

</div>

                </mat-tab>
                <mat-tab label="Patient Passport Photo">
                    <div class="" style="max-width: 900px; margin: auto;">
                        <div class="tab-title py-15" style="text-align: center;">
                            Upload Patient Passport Photo
                        </div>
                        <app-upload-ui allowedFilesCategoryLabel="Image" uploadFieldName="Photo"
                            [allowedFiles]="photoAllowedFiles" [maxFileSize]="photoMaxFileSize" [maxFiles]="1"
                            (filesChanged)="onPhotosUploaded($event)">
                        </app-upload-ui>

                        <section class="agreements-panel" aria-labelledby="agreementsHeading">
                            <div class="agreement-hero">
                                <div class="agreement-hero-header">
                                    <h3 id="agreementsHeading">Agreements & Notifications</h3>
                                    <!-- <p>
                                        A quick summary of the disclosures every hospital presents before activating a chart.
                                        Review each item and open the linked documents in a new tab to keep a copy for your records.
                                    </p> -->
                                </div>
                                <div class="agreement-hero-list">
                                    <!-- @for (statement of telemedicineConsentStatements; track statement) {
                                        <div class="agreement-hero-item">
                                            <mat-icon aria-hidden="true">verified_user</mat-icon>
                                            <span>{{statement}}</span>
                                        </div>
                                    } -->
                                </div>
                            </div>

                            <div class="agreement-checklist">
                                <mat-checkbox color="primary" class="agreement-checkbox"
                                    [checked]="patientAgreementState.privacyPolicy.accepted"
                                    (change)="onAgreementToggle('privacyPolicy', $event.checked)">
                                    I agree to the
                                    <a [routerLink]="agreementLinks.privacyPolicy" target="_blank" rel="noopener">
                                        Privacy Policy
                                    </a>
                                    and acknowledge how my health data is handled.
                                </mat-checkbox>

                                <mat-checkbox color="primary" class="agreement-checkbox"
                                    [checked]="patientAgreementState.treatmentConsent.accepted"
                                    (change)="onAgreementToggle('treatmentConsent', $event.checked)">
                                    I consent to receive medical treatment and healthcare services from practitioners of
                                    this hospital.
                                    <a [routerLink]="agreementLinks.treatmentConsent" target="_blank" rel="noopener">
                                        View full consent
                                    </a>
                                </mat-checkbox>

                                <mat-checkbox color="primary" class="agreement-checkbox"
                                    [checked]="patientAgreementState.telemedicineConsent.accepted"
                                    (change)="onAgreementToggle('telemedicineConsent', $event.checked)">
                                    I understand consultations may occur through telemedicine and that remote care has
                                    limitations.
                                    <a [routerLink]="agreementLinks.telemedicineConsent" target="_blank" rel="noopener">
                                        Telemedicine policy
                                    </a>
                                </mat-checkbox>

                                <mat-checkbox color="primary" class="agreement-checkbox"
                                    [checked]="patientAgreementState.termsOfService.accepted"
                                    (change)="onAgreementToggle('termsOfService', $event.checked)">
                                    I agree to the
                                    <a [routerLink]="agreementLinks.termsOfService" target="_blank" rel="noopener">
                                        Terms of Service
                                    </a>
                                    that govern portal access.
                                </mat-checkbox>

                                <mat-checkbox color="primary" class="agreement-checkbox optional"
                                    [checked]="patientAgreementState.notificationsOptIn.accepted"
                                    (change)="onAgreementToggle('notificationsOptIn', $event.checked)">
                                    Send me SMS/email notifications about appointments, lab updates, and billing
                                    reminders (optional).
                                    <a [routerLink]="agreementLinks.notificationsOptIn" target="_blank" rel="noopener">
                                        Notification preferences
                                    </a>
                                </mat-checkbox>
                            </div>

                            <div class="agreement-doc-links">
                                <span>Full documents:</span>
                                <a [routerLink]="agreementLinks.privacyPolicy" target="_blank" rel="noopener">Privacy
                                    Policy</a>
                                <a [routerLink]="agreementLinks.treatmentConsent" target="_blank"
                                    rel="noopener">Treatment Consent</a>
                                <a [routerLink]="agreementLinks.telemedicineConsent" target="_blank"
                                    rel="noopener">Telemedicine Consent</a>
                                <a [routerLink]="agreementLinks.termsOfService" target="_blank" rel="noopener">Terms of
                                    Service</a>
                            </div>
                        </section>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>

        <!-- Right column: FHIR Result (collapsible, starts collapsed) -->
        <!-- <div style="position: sticky; top: 80px;">
            @if(fhirPatient){
            <div
                style="background: #e8f5e9; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.1); overflow: hidden;">

                <div (click)="toggleFhirPanel()"
                    style="padding: 16px 20px; background: linear-gradient(135deg, #4caf50 0%, #2e7d32 100%); color: white; cursor: pointer; display: flex; align-items: center; justify-content: space-between; user-select: none;">
                    <div style="display: flex; align-items: center; gap: 8px; font-weight: 600; font-size: 15px;">
                        <mat-icon style="color: white;">local_hospital</mat-icon>
                        <span>FHIR R4 Patient Resource</span>
                    </div>
                    <mat-icon style="color: white; transition: transform 0.3s ease;"
                        [style.transform]="isFhirPanelCollapsed ? 'rotate(0deg)' : 'rotate(180deg)'">
                        expand_more
                    </mat-icon>
                </div>


                @if(!isFhirPanelCollapsed){
                <div style="padding: 20px;">

                    <div
                        style="margin-bottom: 12px; padding: 12px; background: white; border-radius: 4px; border-left: 4px solid #2e7d32;">
                        <div style="font-weight: 600; font-size: 13px; margin-bottom: 8px; color: #2e7d32;">
                            📋 Validation Status
                        </div>
                        <div style="display: grid; gap: 6px; font-size: 12px;">

                            <div style="font-weight: 600; color: #d32f2f; margin-top: 4px;">Required:</div>
                            <div style="display: flex; align-items: center; gap: 6px; padding-left: 12px;">
                                @if(validationTracker.required.name.valid){
                                <mat-icon
                                    style="color: #4caf50; font-size: 16px; width: 16px; height: 16px;">check_circle</mat-icon>
                                }@else{
                                <mat-icon
                                    style="color: #f44336; font-size: 16px; width: 16px; height: 16px;">cancel</mat-icon>
                                }
                                <span [style.color]="validationTracker.required.name.valid ? '#4caf50' : '#f44336'">
                                    Patient Name
                                </span>
                            </div>


                            <div style="font-weight: 600; color: #ff9800; margin-top: 8px;">Recommended:</div>
                            <div style="display: flex; align-items: center; gap: 6px; padding-left: 12px;">
                                @if(validationTracker.recommended.gender.valid){
                                <mat-icon
                                    style="color: #4caf50; font-size: 16px; width: 16px; height: 16px;">check_circle</mat-icon>
                                }@else{
                                <mat-icon
                                    style="color: #ff9800; font-size: 16px; width: 16px; height: 16px;">warning</mat-icon>
                                }
                                <span
                                    [style.color]="validationTracker.recommended.gender.valid ? '#4caf50' : '#ff9800'">
                                    Gender
                                </span>
                            </div>
                            <div style="display: flex; align-items: center; gap: 6px; padding-left: 12px;">
                                @if(validationTracker.recommended.birthDate.valid){
                                <mat-icon
                                    style="color: #4caf50; font-size: 16px; width: 16px; height: 16px;">check_circle</mat-icon>
                                }@else{
                                <mat-icon
                                    style="color: #ff9800; font-size: 16px; width: 16px; height: 16px;">warning</mat-icon>
                                }
                                <span
                                    [style.color]="validationTracker.recommended.birthDate.valid ? '#4caf50' : '#ff9800'">
                                    Birth Date
                                </span>
                            </div>
                            <div style="display: flex; align-items: center; gap: 6px; padding-left: 12px;">
                                @if(validationTracker.recommended.telecom.valid){
                                <mat-icon
                                    style="color: #4caf50; font-size: 16px; width: 16px; height: 16px;">check_circle</mat-icon>
                                }@else{
                                <mat-icon
                                    style="color: #ff9800; font-size: 16px; width: 16px; height: 16px;">warning</mat-icon>
                                }
                                <span
                                    [style.color]="validationTracker.recommended.telecom.valid ? '#4caf50' : '#ff9800'">
                                    Contact Info
                                </span>
                            </div>
                        </div>
                    </div>

                    <pre
                        style="background: var(--mat-sys-surface);
                        color: var(--mat-sys-on-surface);
                        padding: 15px; border-radius: 4px; overflow: auto; max-height: 45vh; font-size: 11px; line-height: 1.4;">{{fhirPatient | json}}</pre>

                    <div
                        style="margin-top: 15px; padding: 10px; background: rgba(46, 125, 50, 0.1); border-radius: 4px; font-size: 12px;">
                        <div style="font-weight: 600; margin-bottom: 8px; color: #2e7d32;">� Resource Summary:</div>
                        <div style="display: grid; gap: 4px; color: #555;">
                            <div>👤 Name: {{ fhirPatient.name?.[0]?.given?.[0] }} {{ fhirPatient.name?.[0]?.family }}
                            </div>
                            <div>⚧ Gender: {{ fhirPatient.gender }}</div>
                            <div>📞 Contacts: {{ fhirPatient.telecom?.length || 0 }}</div>
                            <div>📍 Addresses: {{ fhirPatient.address?.length || 0 }}</div>
                            <div>📸 Photos: {{ fhirPatient.photo?.length || 0 }}</div>
                            <div>👨‍👩‍👧 Contacts/Guardians: {{ fhirPatient.contact?.length || 0 }}</div>
                        </div>
                    </div>
                </div>
                }
            </div>
            }@else{
            <div style="padding: 20px; background: #f5f5f5; border-radius: 8px; text-align: center; color: #999;">
                <mat-icon
                    style="font-size: 48px; width: 48px; height: 48px; margin-bottom: 10px;">description</mat-icon>
                <p>FHIR Patient resource will appear here once you submit the form</p>
            </div>
            }
        </div> -->

        @if(fhirPatient){
        <div
            style="
            background-color: transparent;
                display: flex; justify-content: flex-end;
                position: sticky; bottom: 0; z-index: 1001; background: var(--mat-sys-surface-variant); box-shadow: 0 2px 12px rgba(0,0,0,0.15); padding: 8px;">
            <!-- <div style="max-width: 1400px; margin: 0 auto; display: flex; align-items: center; gap: 20px;"> -->
            <button mat-raised-button (click)="submitPatientToServer()" [disabled]="isSubmissionDisabled()">
                <!-- style="flex: 1; max-width: 400px; height: 56px; font-size: 18px; font-weight: 700; letter-spacing: 0.5px; box-shadow: 0 4px 12px rgba(0,0,0,0.2);"
            [style.background]="getRequiredErrorCount() > 0 ? '#9e9e9e' : 'linear-gradient(135deg, #4caf50 0%, #2e7d32 100%)'"
            [style.color]="'white'"> -->
                <!-- <mat-icon style="font-size: 28px; width: 28px; height: 28px; margin-right: 8px;">
                {{getRequiredErrorCount() > 0 ? 'lock' : 'send'}}
            </mat-icon> -->
                @if(getRequiredErrorCount() > 0){
                <span>Complete Required Field(s) to Submit</span>
                }@else if(!hasAcceptedRequiredAgreements){
                <span>Review &amp; Accept Agreements to Continue</span>
                }@else{
                <span>✓ Register</span>
                }
            </button>
            <!-- <div style="display: flex; gap: 12px; align-items: center; font-size: 14px; font-weight: 600;">
                        @if(getRequiredErrorCount() > 0){
                        <span
                            style="background: #f44336; color: white; padding: 8px 16px; border-radius: 20px; display: flex; align-items: center; gap: 6px;">
                            <mat-icon style="font-size: 20px; width: 20px; height: 20px;">error</mat-icon>
                            {{getRequiredErrorCount()}} Required
                        </span>
                        }@else{
                        <span
                            style="background: #4caf50; color: white; padding: 8px 16px; border-radius: 20px; display: flex; align-items: center; gap: 6px;">
                            <mat-icon style="font-size: 20px; width: 20px; height: 20px;">check_circle</mat-icon>
                            Ready to Submit
                        </span>
                        }
                        @if(getRecommendedErrorCount() > 0){
                        <span
                            style="background: #ff9800; color: white; padding: 8px 16px; border-radius: 20px; display: flex; align-items: center; gap: 6px;">
                            <mat-icon style="font-size: 20px; width: 20px; height: 20px;">warning</mat-icon>
                            {{getRecommendedErrorCount()}} Recommended
                        </span>
                        }
                    </div> -->
            <!-- </div> -->
        </div>
        }
    </div>
</div>}
